import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
export default function LeadAiTransformationWave() {
  return <section data-section-id="162363" id="新增設計補助資格-首頁橫幅" className="bg-background relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_0%_0%,var(--color-primary)_0,transparent_50%)] opacity-[0.05]"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_100%_100%,var(--color-secondary)_0,transparent_50%)] opacity-[0.05]"></div>
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-[0.1] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="lg:col-span-7 space-y-8">
            <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5 text-sm font-medium text-primary">
              <Sparkles className="mr-2 h-4 w-4" />
              <span>政府資助計劃官方指南</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-primary leading-[1.2] font-sans">
              政府補助資格指南
            </h1>
            
            <p className="text-[17px] text-muted-foreground max-w-[600px] leading-[1.8] font-sans">
              瑞聲助聽器團隊協助您輕鬆完成申請程序，確保您獲得應有的政府資助，重拾清晰聽力，享受與家人溝通的每一刻。
            </p>
            
            <div className="pt-4 flex flex-col sm:flex-row gap-4">
              <Button variant="outline" size="lg" className="text-lg px-8 py-7 rounded-md font-bold border-2 border-primary text-primary hover:bg-primary/5 transition-all duration-300" asChild>
                <Link to="https://lin.ee/snCVes3" newTab>
                  立即客服諮詢
                </Link>
              </Button>
            </div>

            {}
            <div className="pt-8 flex items-center gap-6 text-sm text-muted-foreground font-medium">
              <div className="flex items-center gap-2">
                <div className="h-2 w-2 rounded-full bg-secondary"></div>
                專業資格審核
              </div>
              <div className="flex items-center gap-2">
                <div className="h-2 w-2 rounded-full bg-secondary"></div>
                一站式申請協助
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none">
            {}
            <div className="relative aspect-[4/5] w-full rounded-tl-[120px] rounded-br-[120px] rounded-tr-2xl rounded-bl-2xl overflow-hidden shadow-2xl border border-border/50 bg-card/50 backdrop-blur-sm group">
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598117/img/ai_brain_victoria_harbour_composition.png" alt="Government Subsidy Guide" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-r from-secondary/40 via-secondary/10 to-transparent mix-blend-multiply"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background/60"></div>
              
              {}
              <div className="absolute bottom-8 left-8 right-8 p-6 rounded-xl bg-background/90 backdrop-blur-md border border-white/20 shadow-xl">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-bold text-primary tracking-wider uppercase">申請進度</span>
                  <span className="flex h-2 w-2 relative">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-secondary"></span>
                  </span>
                </div>
                <div className="h-1.5 w-full bg-muted rounded-full overflow-hidden">
                  <div className="h-full bg-primary w-[92%] rounded-full"></div>
                </div>
                <div className="mt-2 flex justify-between text-[10px] text-muted-foreground font-sans">
                  <span>成功獲批率</span>
                  <span>92%</span>
                </div>
              </div>
            </div>

            {}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[radial-gradient(circle,var(--color-secondary)_0%,transparent_70%)] opacity-30 blur-xl"></div>
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-[radial-gradient(circle,var(--color-primary)_0%,transparent_70%)] opacity-30 blur-xl"></div>
          </div>

        </div>
      </div>
    </section>;
}